/**
 * Unified chart color palette for all Charger Metrics graphs.
 *
 * Every chart on the Charger Summary → Metrics tab imports from here so that
 * colors are consistent across the LineBarComposedChart, StepChart (Connection
 * Status), and StateTimeline.
 *
 * The palette uses Tailwind's 500-weight scale for WCAG-friendly contrast.
 */

export const CHART_PALETTE = {
  // ── Positive / Active states ──
  green: "#10b981", // Emerald-500 — Online, EV Plugged In, Green Charging

  // ── Informational / AI / System ──
  blue: "#3b82f6", // Blue-500 — AI Optimization, Charging Started

  // ── User / Manual actions ──
  violet: "#8b5cf6", // Violet-500 — User Set Schedules

  // ── Warnings / Transitions ──
  amber: "#f59e0b", // Amber-500 — Power Consumed, Charging Stopped

  // ── Supplementary / Secondary data ──
  cyan: "#06b6d4", // Cyan-500 — Power Offered, Fault Cleared

  // ── Negative / Error states ──
  red: "#ef4444", // Red-500 — Fault Detected, EV Plugged Out, Offline

  // ── Neutral / Defaults ──
  slate: "#94a3b8", // Slate-400 — Default/unknown segments
  gray: "#64748b", // Slate-500 — Secondary text

  // ── UI chrome (axes, grids, text) ──
  textPrimary: "#1e293b",
  textSecondary: "#64748b",
  gridLines: "#e2e8f0",
  gridBackground: "#f8fafc",
};

export const CHART_PALETTE_DARK = {
  ...CHART_PALETTE,
  textPrimary: "#e2e8f0",
  textSecondary: "#94a3b8",
  gridLines: "#334155",
  gridBackground: "#0f172a",
};
